import React, { useEffect, useCallback, useState } from "react";
import { apiGet } from "helpers/Request";
import { useAuth } from "hooks/Auth";
import LoadingIndicator from "components/General/LoadingIndicator";
import MainBlock from "components/DesignSystem/LayoutBlocks/MainBlock";
import { useParams, useHistory, useLocation } from "react-router-dom";
import ErrorShell from "components/Shells/ErrorShell";

function ContentFinder(props) {
    const { uuid } = useParams();
    const history = useHistory();
    const location = useLocation();
    const auth = useAuth();
    const [loading, setLoading] = useState(true);

    const getContent = useCallback(() => {
        apiGet("/v4/attachment/" + uuid, auth.publication)
            .then((resp) => {
                if (resp.uuid) {
                    history.push(`/app/${resp.type}/${resp.uuid}`);
                    return;
                }
                throw new Error("Item not found");
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [uuid, auth.publication, history, setLoading]);

    useEffect(() => {
        getContent();
    }, [getContent, location]);

    if (loading) {
        return (
            <MainBlock>
                <LoadingIndicator />
            </MainBlock>
        );
    }

    return (
        <MainBlock>
            <ErrorShell message="Unable to locate that item. Please try again." />
        </MainBlock>
    );
}

export default ContentFinder;
